import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description: 'By {name}',
    descriptionWithDate: 'By {name} · {date}',
    label: 'Bank transfer',
  },
  fr: {
    description: 'Par {name}',
    descriptionWithDate: 'Par {name} · {date}',
    label: 'Virement sortant',
  },
} as const);

export default locales;
